/// <amd-module name="Build/Admin/Common/Stores/NotificationStore" />
import { Store } from "VSS/Reflux/Store";
import { IButtonProps } from "VSSUI/Button";

export enum NotificationType {
    info,
    warning,
    error,
}

export interface INotification {
    notificationType: NotificationType;
    message: string;
    buttonProps?: IButtonProps[];
}

export class NotificationStore extends Store {
    public state: INotification[] = [];

    constructor() {
        super("NotificationStoreChanged");
    }

    public dismissNotification = (notification: INotification): void => {
        this.state =  this.state.filter(n => n !== notification);
        this.emitChanged();
    }

    public clearNotifications = (): void  => {
        this.state = [];
        this.emitChanged();
    }

    public addNotification = (notification: INotification): void => {
        this.state = this.state.concat(notification);
        this.emitChanged();
    }
}
